import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center my-10" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.logoImg ?? undefined,
          width: "50%",
          height: "50%"
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-3 font-900 text-center" }, [
          _createTextVNode(" MAINTENANCE"),
          _createElementVNode("span", { class: "color-primary" })
        ], -1)),
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.maintenanceMessage), 1)
      ])
    ]),
    _: 1
  }))
}